import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const AutocompleteAction = createActionGroup({
  source: 'Autocomplete',
  events: {
    'Set Keyword': props<{ value: string }>(),
    'Set List': props<{ value: any[] }>(),
    'Clear List': emptyProps(),
  },
});
